import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { RolesApiClient } from "../../web-api-client";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { appConfig } from "../../appconfig";

export function useRoles() {
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["roles"],
    queryFn: async () => {
      const client = new RolesApiClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", { replace: true, state: { from: window.location.pathname } }),
        }),
      });

      const data: any = await client.getRoles();
      return data;
    },
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
